export const LEGAL_LOCALE = "en-ZA";
export const LEGAL_EFFECTIVE_DATE = "2026-08-25";
export const LEGAL_VERSION = "1.1";

export const legalMessages = {
  privacy: {
    eyebrow: "Legal",
    title: "Privacy Policy",
    summary:
      "This policy explains what information Abomination Racing League (ARL) handles when you visit our website or take part in the league.",
    effectiveLabel: "Effective date",
    versionLabel: "Version",
    sections: [
      {
        title: "Information we handle",
        paragraphs: [
          "The ARL website publishes league information such as driver names or chosen display names, team membership, race results, standings, penalties and event media.",
          "When you visit the website, our hosting and infrastructure providers may process limited technical information, including your IP address, browser type, device information, requested pages and timestamps. This information is generally used to deliver, secure and maintain the website.",
          "If you contact ARL or join our community through Discord, we may receive the profile details and messages you choose to share on that service.",
        ],
      },
      {
        title: "Participation data",
        paragraphs: [
          "Participation in league events generates official sporting records. ARL records and may publicly publish driver names/display names, team and vehicle information, qualifying results, race results, lap times, penalties, points, standings and related competition statistics.",
        ],
      },
      {
        title: "How we use information",
        list: [
          "Run league events and maintain accurate sporting records.",
          "Publish results, standings, disciplinary outcomes and community media.",
          "Respond to questions, registrations and support requests.",
          "Protect the website and community from abuse, fraud and security threats.",
          "Meet legal obligations and resolve disputes.",
        ],
      },
      {
        title: "Legal basis and choices",
        paragraphs: [
          "Where applicable law requires a legal basis, we process information to operate the league, for our legitimate interests in managing a fair and secure community, with your consent where requested, or to comply with law. You may withdraw consent at any time, although this does not affect earlier lawful processing.",
        ],
      },
      {
        title: "Sharing and third parties",
        paragraphs: [
          "We may share information with service providers that host or support the website and league operations, with race officials who need it to perform their roles, or where disclosure is required by law. Public league records can be viewed and reshared by anyone.",
          "Links to Discord and other third-party services take you to services governed by their own privacy policies. ARL does not control how those services process your information.",
        ],
      },
      {
        title: "Retention and security",
        paragraphs: [
          "Sporting records may be kept as part of ARL's historical archive. Other information is kept only as long as reasonably needed for the purpose for which it was collected, including legal, security and dispute-resolution needs.",
          "We use reasonable organisational and technical safeguards, but no online service can guarantee absolute security.",
        ],
      },
      {
        title: "Your privacy rights",
        paragraphs: [
          "Depending on where you live, you may have rights to ask for access, correction, deletion, restriction or objection, or to lodge a complaint with your local data-protection authority. These rights may be limited where ARL must preserve an accurate sporting record or comply with law.",
        ],
      },
      {
        title: "Children",
        paragraphs: [
          "If you are not old enough to consent to the processing of your information under the law where you live, a parent or legal guardian must approve your participation and use of the community services.",
        ],
      },
      {
        title: "Contact and updates",
        paragraphs: [
          "For privacy requests or questions, contact an ARL administrator through the official Discord community linked on this website. We may update this policy as the league or law changes. The effective date and version above identify the current policy.",
        ],
      },
    ],
  },
  terms: {
    eyebrow: "Legal",
    title: "Terms of Use",
    summary:
      "These terms govern your use of the ARL website and participation in website-connected league activities.",
    effectiveLabel: "Effective date",
    versionLabel: "Version",
    sections: [
      {
        title: "Accepting these terms",
        paragraphs: [
          "By using this website, you agree to these terms and the ARL rules and regulations. If you do not agree, do not use the website. League participation may also require acceptance of event-specific rules communicated by ARL officials.",
        ],
      },
      {
        title: "Permitted use",
        paragraphs: [
          "You may use the website for personal, non-commercial access to ARL information and community activities. You must comply with applicable law and respect other community members.",
        ],
        list: [
          "Do not disrupt, overload, probe or attempt to bypass the website's security.",
          "Do not scrape or reuse website content in a way that harms ARL or its members.",
          "Do not impersonate another person or submit false or misleading league information.",
          "Do not use the website to distribute malicious code or unlawful, abusive or infringing material.",
        ],
      },
      {
        title: "League participation",
        paragraphs: [
          "Participation is subject to the current sporting and disciplinary rules. ARL officials may review incidents, apply penalties, correct results, restrict participation or remove members to protect fair competition and the community. Decisions and appeal processes are governed by the published rules.",
          "Participation in league events generates official sporting records. ARL records and may publicly publish driver names/display names, team and vehicle information, qualifying results, race results, lap times, penalties, points, standings and related competition statistics.",
        ],
      },
      {
        title: "Content and intellectual property",
        paragraphs: [
          "The website's design, branding and original content belong to ARL or their respective licensors. Game names, logos and other third-party material remain the property of their owners. No affiliation or endorsement is implied unless expressly stated.",
          "If you submit race media or other content for publication, you confirm that you have the right to share it and grant ARL a non-exclusive, worldwide, royalty-free licence to host, reproduce and display it for league, archive and promotional purposes. You retain ownership of your content.",
        ],
      },
      {
        title: "Accuracy and availability",
        paragraphs: [
          "We aim to keep league information accurate, but results, schedules and standings may be corrected or changed. The website is provided on an “as available” basis and may be interrupted, changed or withdrawn without notice. Always check official ARL announcements for time-sensitive event information.",
        ],
      },
      {
        title: "Third-party services",
        paragraphs: [
          "The website links to services such as Discord. Your use of those services is governed by their own terms. ARL is not responsible for third-party services, content or availability.",
        ],
      },
      {
        title: "Liability",
        paragraphs: [
          "To the fullest extent permitted by law, ARL and its volunteer administrators are not liable for indirect, incidental or consequential loss arising from use of the website or participation in league activities. Nothing in these terms excludes liability that cannot lawfully be excluded or limits your mandatory consumer rights.",
        ],
      },
      {
        title: "Changes and contact",
        paragraphs: [
          "We may update these terms when the website, league or applicable rules change. Continued use after an update means you accept the revised terms. The effective date and version above identify the current terms.",
          "For questions about these terms, contact an ARL administrator through the official Discord community linked on this website.",
        ],
      },
    ],
  },
};
